// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mi-sweetalert-container{z-index:99999!important}", "",{"version":3,"sources":["webpack://./resources/js/components/pages/MyStyles1.css"],"names":[],"mappings":"AAAA,yBACE,uBACF","sourcesContent":[".mi-sweetalert-container {\r\n  z-index: 99999 !important; /* Un número más alto que el de otros modales */\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
